module.exports = __webpack_public_path__ + "static/media/corporate-services-img55.d307ed47.jpg";